/** @namespace account */
import { concatAll } from '~/utils/lib/core/prelude'

export const getPasswordRestoreRoute = (
  /** @type {string} */ token,
  ) => concatAll([
    `/account`,
    `/restore`,
    `?token=${token}`,
  ])

